import axios from "axios";
import * as actionTypes from "./actionTypes";

const dominio = process.env.REACT_APP_DOMINIO;
const base_url = `${dominio}/emisoras/tipo-inscripcion`;

const setTipoInscripcion = (data = null) => {
  return {
    type: actionTypes.FETCH_TIPOINSCRIPCION_SUCCESS,
    tipoInscripcion: data
  };
};

export const filterTipoInscripcion = (language) => {
  return dispatch => {
    axios.get(base_url).then(response => {
        if (language && language !== "es") {
          response.data = response.data.map(item => {
            if(item.id === 1) {
              item.nombre = "Traditional";
            } else if(item.id === 2) {
              item.nombre = "Simplified";
            }
            return {
              id: item.id,
              nombre: item.nombre
            };
          });
        }
        dispatch(setTipoInscripcion(response.data));
      })
      .catch(() => {dispatch(setTipoInscripcion())});
  };
};
